export enum Days {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export interface ICreateUpdateDaySegmentRequest {
  name?: string;
  days?: Days[];
  start?: string;
  end?: string;
}

export interface IDaySegment {
  id: string;
  siteId: string;
  name: string;
  days: Days[];
  start: string;
  end: string;
  endsNextDay?: boolean;
  createdAt?: string;
  updatedAt?: string;
}
